import {
  Component, Input, Output, EventEmitter, ChangeDetectorRef, ChangeDetectionStrategy,
  ViewChild, ElementRef,
} from '@angular/core';
import * as _ from 'lodash';
import { UntypedFormControl } from '@angular/forms';


@Component({
  moduleId: module.id,
  selector: 'modal-header-search',
  templateUrl: 'modal-header-search.component.html',
  styleUrls: ['modal-header-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalHeaderSearchComponent {

  @Input() title: string;
  @Input() shortPlaceholder: string = 'Search...';
  @Input() expandedPlaceholder: string = 'Search...';
  @Input() hiddenSearch: boolean = false;
  @Input() headerRightContent: boolean = false;

  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  @Output() cancelClick: EventEmitter<any> = new EventEmitter();
  @Output() clearClick: EventEmitter<any> = new EventEmitter();
  @Output() runSearch: EventEmitter<any> = new EventEmitter();

  @ViewChild('searchInput', {static: false})
  searchInput: ElementRef | void;

  searchControl: UntypedFormControl = new UntypedFormControl();
  isControlExpanded: boolean = false;
  lastSearchedTerm: string;

  constructor(
    private ref: ChangeDetectorRef,
  ) {}

  onModalCloseClick(event: any) {
    event.stopPropagation();
    this.closeModal.emit();
  }

  onCancelClick(event: any) {
    event.stopPropagation();
    this.collapseSearch();
    this.searchControl.reset(this.lastSearchedTerm);
    this.cancelClick.emit();
  }

  onClearClick(event: any) {
    event.stopPropagation();
    this.searchControl.reset();
    this.clearClick.emit();
  }

  onSearchClick(event: any) {
    event.stopPropagation();
    this.emitRunSearch();
  }

  onKeyupEnter() {
    this.emitRunSearch();
  }

  public reset(): void {
    this.isControlExpanded = false;
    this.lastSearchedTerm = '';
    this.searchControl.reset();
  }

  public expandSearch(): void {
    if (this.hiddenSearch) { return; }
    this.isControlExpanded = true;
    this.lastSearchedTerm = this.searchControl.value;
    _.defer(() => {
      if (this.searchInput) {
        this.searchInput.nativeElement.focus();
      }
    });
    this.ref.markForCheck();
  }

  public collapseSearch(): void {
    this.isControlExpanded = false;
    this.ref.markForCheck();
  }

  public setSearchTerm(value: string): void {
    this.searchControl.setValue(value);
  }

  private emitRunSearch(): void {
    if (!this.searchControl.value) { return; }
    this.isControlExpanded = false;
    this.runSearch.emit(this.searchControl.value);
  }
}
